export interface IButtonParameters {
}

export default class ButtonParameters implements IButtonParameters {
    private _right: string;

    public constructor(right: string, datas?: any) {
        this._right = right ?? "";
    }

    /** Droit visé */
    public get Right(): string {
        return this._right;
    }

    /** Droit visé */
    public set Right(value: string) {
        this._right = value;
    }

    /** Permet de définir les droits d'affichage suivant ceux fixés sur le bouton */
    public static GetRight(buttonRight?: string, defaultRight?: string) {
        return buttonRight != undefined && buttonRight != '' ? buttonRight : defaultRight;
    }
}